<template>
    <div class="help">
        <h1>Help</h1>
        <div>
            my.stekz.com is for building complete software solutions together.
            Making it easy and fun to collaborate on any aspect. From writing
            high level design documents to creating, deploying and monitoring
            the resulting software. To grasp the full power of my.stekz there
            are a few fundamental aspects to understand.
        </div>
        <h2>What is a Stek?</h2>
        <div>
            A Stek is an organized collection of all the digital items that make
            up your software solution. Design documents, source code,
            discussions, domain models, functional requirements,...everything.
            To keep track of things my.stekz organizes items into related
            categories. Guiding principles are Domain Driven Design and
            BizDevOps. The key takeaway for now is the following way of
            thinking:
        </div>
        <ol>
            <li>A business operates in one or more <b>domains</b></li>
            <li>A domain offers <b>products</b></li>
            <li>A product is the result of <b>processes</b></li>
            <li>A process can be automated by <b>applications</b></li>
            <li>An application depends on operational <b>services</b></li>
        </ol>
        <div>
            Where Domains, Products and Processes belong to the business (‘biz’)
            realm, Applications to the development (‘dev’) realm, and Services
            to the operational (‘ops’) realm. From top to bottom this can be
            visualized as follows:
        </div>
        <p>
            <img
                id="overview"
                alt="overview"
                src="../assets/docs/overview.png"
            />
        </p>
        <h2>The hierarchy of a Stek</h2>
        <div>
            Remember that a Stek can have multiple domains. And each domain can
            offer multiple products. And each Product... So the hierarchy is:
        </div>
        <p>
            <img
                id="hierarchy"
                alt="hierarchy"
                src="../assets/docs/overview_hierarchy.png"
            />
        </p>
        <h2>Practical examples</h2>
        <div>
            A practical example with one domain (Finance) with one Product,
            Process, Application and Service:
        </div>
        <p>
            <img
                id="example_domain"
                alt="example_domain"
                src="../assets/docs/overview_example_domain.png"
            />
        </p>
        <div>And a practical implementation with multiple domains:</div>
        <p>
            <img
                id="example_domains"
                alt="example_domains"
                src="../assets/docs/overview_example_domains.png"
            />
        </p>
        <div>And the type of items you could find per category:</div>
        <p>
            <img
                id="items"
                alt="items"
                src="../assets/docs/overview_Items.png"
            />
        </p>
        <h2>Under the hood</h2>
        <div>
            Guiding principle of Stekz is the empowerment of operators,
            developers and business related roles. But also that users of
            my.stekz are in total control of their own data. That is why
            my.stekz hosts all content as Git repositories on its own or
            external Git servers. To keep things modular so teams can work
            independently on specific areas of a Stek, each Stek consists of a
            hierarchy of Git repositories:
        </div>
        <p>
            <img
                id="git_tree"
                alt="git_tree"
                src="../assets/docs/overview_git_tree.png"
            />
        </p>
        <div>
            This means all content is version controlled and can be worked on in
            a distributed manner. For instance, if a development team wants to
            locally develop a specific application (‘dev’) they simply checkout
            that repository. The important thing to realize is that there is
            always a clear relationship between items. Mentioned development
            team can always easily find and access things like the related BPMN
            process, product documentation, functional requirements, domain
            model, etcetera.
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "Help",
});
</script>
